<template>
    <div class="container-fluid" >

        <h3>Асуулгад оролцох</h3>
        <div class="row">

            <div class="col-lg-4" v-for="(qa) in asuulga" v-bind:key="qa.id">

              <!-- Basic Card Example -->
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">{{qa.name}}</h6>
                </div>
                <div class="card-body">
                  <p>{{qa.description}}</p>
                  <button class="btn btn-primary" @click="_goPublic(qa.id)">оролцох</button>
                </div>
              </div>

            </div>
          </div>
   
    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')

    export default {
        data() {
            return {
                asuulga:[],

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },


        methods: {

            _getQA(){
                this.asuulga=[];

                fb.db.collection("asuulga").onSnapshot(querySnapshot=> {
                    querySnapshot.forEach(doc=> {
                        let object=doc.data()
                        object.id = doc.id
                        this.asuulga.push(object);
                    });
                });


            
            },
            _goPublic(postId){
                this.$router.push({ name: 'QuestionsAnswer', params: { qaId: postId} })
            },

  
        },
        created() {
            var _this=this;

            this._getQA();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
